/*
 * @Descripttion:
 * @Author: xiang.gao
 * @Date: 2022-05-25 21:58:17
 * @LastEditors: xiang.gao xiang.gao@travel-easy.com
 * @LastEditTime: 2023-06-19 21:48:48
 */
import { NumberOrString } from "../type/common";

export const productItemData: ProductItem = {
  id: "",
  product_identifier_id: "0",
  name: "",
  original_color: "",
  brand_id: 0,
  color: 0,
  country_of_origin: "",
  gtin: "",
  brand_article_no: "",
  merchant_article_no: "",
  source_link: "",
  net_weight: "",
  weight: "",
  package_material: "",
  name_en: "",
  gallery: [],
  official_prices: [],
  __show: {
    brand_id: "",
    size: "",
    color: "",
  },
};

export const skuItemData: RelationSku = {
  id: "",
  sku_id: "",
  name: "",
  name_en: "",
  brand_article_no: "",
  merchant_article_no: "",
  product_identifier_id: "0",
  gallery: [],
  brand: "",
  range_size: "",
  size: "",
  color: "",
  original_color: "",
  source_link: "",
};

export interface RelationSku {
  id: string;
  sku_id: string;
  name: string;
  name_en: string;
  brand_article_no: string;
  merchant_article_no: string;
  product_identifier_id: string;
  gallery: ProductItemImage[];
  brand: string;
  size: string;
  range_size: string,
  color: string;
  original_color: string;
  source_link: string;
}

export interface ProductItem {
  id: NumberOrString;
  product_identifier_id: string;
  gallery: Array<ProductItemImage>;
  name_en: string;
  name: string;
  color: NumberOrString;
  brand_id: NumberOrString;
  brand_article_no: string;
  merchant_article_no: string;
  original_color: string;
  net_weight: string;
  weight: string;
  package_material: string;
  gtin: string;
  country_of_origin: string;
  official_prices: Array<ProductItemOfficialPrices>;
  source_link: string;
  __show: ProductItemShow;
}

export interface ProductItemImage {
  id: number | string;
  origin_url: string;
}

export interface ProductItemOfficialPrices {
  currency: string;
  price: string;
  country_iso_2: string;
}

interface HsCodes {
  DE?: string;
  CN?: string;
}

export interface ProductItemShow {
  brand_id?: string;
  size?: string;
  color?: string;
  product_gallery?: string;
  product_identifier_id?: string;
  product_name?: string;
}
